import ServiceCard from '@/components/ServiceCard'

const services = [
  { name: 'Control de contaminantes', icon: 'ph ph-shield-check' },
  { name: 'Análisis microbiológico', icon: 'ph ph-flask' },
  { name: 'Control de plagas', icon: 'ph ph-bug' },
  { name: 'Certificaciones alimentarias', icon: 'ph ph-certificate' },
  { name: 'Higiene en procesos', icon: 'ph ph-spray-bottle' },
  { name: 'Control de calidad', icon: 'ph ph-check-circle' },
  { name: 'Estudios de residuos', icon: 'ph ph-swap' },
  { name: 'Auditorías sanitarias', icon: 'ph ph-search' },
]

function Bromatologia() {
  return (
    <div className="relative min-h-screen bg-background">
      <div className="watermark" aria-hidden="true"></div>
      <section className="page-hero h-64 md:h-80 flex items-center justify-center">
        <img
          src="/Docs/Fotos/Horcon foto.png"
          alt="Veterinario en bromatología"
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-primary/60"></div>
        <h1 className="relative text-3xl md:text-4xl font-bold text-white">Bromatología</h1>
      </section>

      <section className="py-12 md:py-16 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, index) => (
              <ServiceCard
                key={service.name}
                title={service.name}
                icon={service.icon}
                href="/contacto"
                index={index}
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default Bromatologia